import $ from 'jquery';

export function waitForModalHidden() {
    return new Promise(resolve => {
        if (document.body.classList.contains('modal-open')) {
            $(document).one('hidden.bs.modal', () => resolve());
        } else {
            resolve();
        }
    });
}
